import { render } from "./glusterfs.vue?vue&type=template&id=42c736c7"
import script from "./glusterfs.vue?vue&type=script&lang=js"
export * from "./glusterfs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__